export default "__VITE_ASSET__CPvYbCkh__"